import dayjs from 'dayjs'

const YEARLESS_MONTH_DAY =
    /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?\s+\d{1,2}$/i
const YEARLESS_DAY_MONTH =
    /^\d{1,2}\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*\.?$/i

const toDayjs = (value) => {
    try {
        if (value == null || value === '') return null
        if (typeof value === 'boolean') return null
        if (Array.isArray(value)) return null

        if (typeof value === 'object' && !(value instanceof Date)) {
            if (value.$date != null) return toDayjs(value.$date)
            if (typeof value.toDate === 'function') {
                return toDayjs(value.toDate())
            }
            return null
        }

        if (typeof value === 'number') {
            if (!Number.isFinite(value)) return null
            const parsed = dayjs(value < 1e12 ? value * 1000 : value)
            return parsed.isValid() ? parsed : null
        }

        if (value instanceof Date) {
            if (Number.isNaN(value.getTime())) return null
            const parsed = dayjs(value)
            return parsed.isValid() ? parsed : null
        }

        if (typeof value !== 'string') return null

        const trimmed = value.trim()
        if (!trimmed) return null
        if (/^today$/i.test(trimmed)) return dayjs()
        if (/^yesterday$/i.test(trimmed)) return dayjs().subtract(1, 'day')

        if (/^\d{10,}$/.test(trimmed)) {
            const n = Number(trimmed)
            if (!Number.isFinite(n)) return null
            const parsed = dayjs(n < 1e12 ? n * 1000 : n)
            return parsed.isValid() ? parsed : null
        }

        const withYear =
            YEARLESS_MONTH_DAY.test(trimmed) || YEARLESS_DAY_MONTH.test(trimmed)
                ? `${trimmed}, ${dayjs().year()}`
                : trimmed

        const parsed = dayjs(withYear)
        if (!parsed.isValid()) return null
        if (parsed.year() === 2001 && !trimmed.includes('2001')) {
            return parsed.year(dayjs().year())
        }
        return parsed
    } catch {
        return null
    }
}

export const formatCommentDate = (date) => {
    try {
        const commentDate = toDayjs(date)
        if (!commentDate) return ''

        const now = dayjs()
        const time = commentDate.format('h:mm A')

        if (commentDate.isSame(now, 'day')) {
            return `Today, ${time}`
        }
        if (commentDate.isSame(now.subtract(1, 'day'), 'day')) {
            return `Yesterday, ${time}`
        }

        const daysDiff = now
            .startOf('day')
            .diff(commentDate.startOf('day'), 'day')
        if (daysDiff > 1 && daysDiff <= 7) {
            return `${daysDiff} days ago, ${time}`
        }

        const dateLabel =
            commentDate.year() === now.year()
                ? commentDate.format('MMM D')
                : commentDate.format('MMM D, YYYY')
        return `${dateLabel}, ${time}`
    } catch {
        return ''
    }
}
